import { useCallback } from 'react';

import { useGenericSend } from '../useGenericSend';
import { IServerSendResponse, TServerSendRequest } from '../../types';

export const useConvertLoyaltyPointsToRealMoney = () => {
    const send = useGenericSend();

    return useCallback(async (): Promise<IServerSendResponse> => await send<TServerSendRequest, IServerSendResponse>({
        ID: 35206,
        description: 'Convert Loyalty Points to Real Money',
        responses: [35207, 35208]
    }), [send]);
};
